// extracted by mini-css-extract-plugin
export default {"alternativeBrowsers":"index-module__VgUE4","logo":"index-module__FIfJD","installCode":"index-module__Q8lNE","text":"index-module__Kyh9v"};